import EnterCode from './EnterCode';

export default EnterCode;